import {
  JACKETS_SLUG,
  TROUSERS_SLUG,
} from '../modules/my-measurements/my-measurements.constants';
import {
  SLUG_ACCOUNT_DETAILS,
  SLUG_BILLING_ADDRESS,
  SLUG_SHIPPING_ADDRESS,
  URL_MY_MEASUREMENTS,
  URL_PROFILE,
} from './constants';
import { getTitleForSlug } from './string';

/***************************************************************
 * Measurements
 ***************************************************************/
export const isJacketPath = (pathname) => pathname.endsWith(JACKETS_SLUG);
export const isTrousersPath = (pathname) => pathname.endsWith(TROUSERS_SLUG);

export const isMeasurementsPath = (pathname) =>
  pathname.startsWith(`${URL_MY_MEASUREMENTS}/`);

export const getMeasurementsTitle = (pathname) => {
  if (isJacketPath(pathname)) return 'Jacket Measurements | AskOkey';
  if (isTrousersPath(pathname)) return 'Trousers Measurements | AskOkey';

  return 'My Measurements | AskOkey';
};

/***************************************************************
 * Profile
 ***************************************************************/
export const isAccountDetailsPath = (pathname) =>
  pathname.endsWith(SLUG_ACCOUNT_DETAILS);
export const isBillingAddressPath = (pathname) =>
  pathname.endsWith(SLUG_BILLING_ADDRESS);
export const isShippingAddressPath = (pathname) =>
  pathname.endsWith(SLUG_SHIPPING_ADDRESS);
export const isProfilePath = (pathname) =>
  pathname.startsWith(`${URL_PROFILE}/`);

export const getProfileTitle = (pathname) => {
  if (isAccountDetailsPath(pathname)) return 'Account Details | AskOkey';
  if (isBillingAddressPath(pathname)) return 'Billing Address | AskOkey';
  if (isShippingAddressPath(pathname)) return 'Shipping Address | AskOkey';

  return 'Profile | AskOkey';
};

export const getTitleForLocation = (location) => {
  const { pathname } = location;
  if (!pathname) return 'AskOkey';

  if (isMeasurementsPath(pathname)) return getMeasurementsTitle(pathname);
  if (isProfilePath(pathname)) return getProfileTitle(pathname);
  return getTitleForSlug(pathname);
};
